export enum LoiSubmissionStatus {
    WaitingSubmission,
    Submitted,
    AdminReview,
    SellerReview,
    Executed,
    Rejected,
}
